<template>
<div>
  <content-nav-bar class="content-nav-bar">
    <h5 class="is-size-4 has-text-centered level-item">Edit Asset</h5>
    <a v-on:click="submit()" class="add button level-item">
      <i class="far fa-save"></i>
      Save
    </a>
    <p v-if="message" class="level-item">{{ message }}</p>
    <loader class="level-item" :showLoader="showLoader">Saving Asset</loader>
  </content-nav-bar>
  <div class="form-section">
    <fieldset class="fieldset">
      <legend>Edit Asset</legend>
          <form-field icon="name" title="Label">
            <input v-model="label"
              class="input"
              type="text"
              placeholder="Name">
          </form-field>

          <form-field icon="tag" title="Tags">
            <multiselect
              v-model="tags"
              tag-placeholder="Add this as new tag"
              placeholder="Search or add a tag"
              :multiple="true"
              :taggable="true"
              :options="[]"
              @tag="addTag">
              <template slot="tag" slot-scope="props">
                <b-tag closable @close="removeTag(props.option)">
                  {{ props.option }}
                </b-tag>
              </template>
            </multiselect>
          </form-field>
    </fieldset>
  </div>
</div>

</template>

<script>
import ContentNavBar from '@/components/ContentNavBar.vue';
import Multiselect from 'vue-multiselect';
import FormField from '@/components/forms/FormField.vue';
import Loader from '@/components/Loader.vue';

export default {
  name: 'AssetEdit',
  components: {
    Loader,
    ContentNavBar,
    Multiselect,
    FormField,
  },
  props: {
    asset: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      message: null,
      showLoader: false,
      label: this.asset.label,
      tags: this.asset.tags,
    };
  },
  methods: {
    addTag(tag) {
      this.tags.push(tag);
    },
    removeTag(tag) {
      this.tags = this.tags.filter(t => t !== tag);
    },
    async submit() {
      this.showLoader = true;
      const asset = await this.$store.dispatch('primary/updateAsset', {
        uuid: this.asset.uuid,
        label: this.label,
        tags: this.tags,
      });
      this.showLoader = false;
      if (asset) {
        this.message = 'Asset updated';
        // this.$router.push({ name: 'assets.index' });
      }
    },
  },
};
</script>

<style lang="scss" scoped>

.pad-top {
  margin-top: $content-padding;
}
</style>
